import { render, staticRenderFns } from "./GalleryListEditLayout.vue?vue&type=template&id=67703a92&scoped=true"
import script from "./GalleryListEditLayout.vue?vue&type=script&lang=js"
export * from "./GalleryListEditLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67703a92",
  null
  
)

export default component.exports